import { Box, NotificationsNoneOutlinedIcon } from '@shared/components';

import { useGetMyNotifications } from '../../../hooks';
import MenuItem, { type MenuItemProps } from '../menu-item';

type NotificationMenuItemProps = Pick<MenuItemProps, 'minified'>;
type NotificationMenuItemPropsWithOnclick = NotificationMenuItemProps & { onClick?: () => void };

function NotificationMenuItem(props: Readonly<NotificationMenuItemPropsWithOnclick>) {
  const { onClick, minified } = props;
  const { notificationsData } = useGetMyNotifications();

  return (
    // TODO: add notification badge if have unread notifications when integrating with API
    <Box sx={{ position: 'relative' }}>
      <MenuItem
        {...props}
        label='การแจ้งเตือน'
        icon={<NotificationsNoneOutlinedIcon />}
        onClick={onClick}
      />

      {notificationsData.length > 0 ? (
        <Box
          sx={(theme) => ({
            position: 'absolute',
            width: 8,
            height: 8,
            top: minified ? 'calc(50% - 16px)' : 'calc(50% - 1px)',
            right: minified ? theme.spacing(1) : theme.spacing(2),
            borderRadius: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: theme.palette.error.main,
          })}
        />
      ) : null}
    </Box>
  );
}

export default NotificationMenuItem;
